<!-- NAVIGATION BAR -->
<nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top">
    <div class="container-fluid px-4">
        <a class="navbar-brand" href="#">
            <img src="../../../assets/svg/DDF-Logo-White.svg" alt="" height="44px">
        </a>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav me-auto mb-4 mt-4 mb-lg-0 mt-lg-0">
                <ul class="navbar-nav">
                    <li *ngFor="let menu of mostrarMenu" class="nav-item" [ngClass]="{'dropdown': menu.subMenu && menu.subMenu.length > 0, 'nav-link-active': isActive(menu.url) || hasActiveSubMenu(menu.subMenu ?? []) }">

                        <a class="nav-link" [ngClass]="{'dropdown-toggle': menu.subMenu && menu.subMenu.length > 0 }" aria-current="page" [routerLink]="menu.url ? ['/', menu.url] : null" routerLinkActive="nav-link-active" [routerLinkActiveOptions]="{ exact: false }" [attr.data-bs-toggle]="menu.subMenu && menu.subMenu.length > 0 ? 'dropdown' : null">
                            <i *ngIf="menu.icono" [class]="menu.icono"></i> {{menu.nombre}}
                        </a>

                        <ul *ngIf="menu.subMenu && menu.subMenu.length > 0" class="dropdown-menu">
                            <li *ngFor="let subMenu of menu.subMenu" [ngClass]="{'nav-link-active1': isActive(subMenu.url)}">
                                <a class="dropdown-item" [routerLink]="subMenu.url ? ['/', subMenu.url] : null" routerLinkActive="nav-link-active1" [routerLinkActiveOptions]="{ exact: false }">
                                    <i [class]="subMenu.icono"></i> {{subMenu.nombre}}
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </ul>

            <div class="col-12 col-lg text-end">
                <div class="btn-group">
                    <div class="d-flex align-items-center ms-auto">
                        <div class="text-light me-3">
                            <div>{{ username }}</div>
                            <div class="small">{{ rol }}</div>
                            <div *ngIf="estamos !== null" class="small resaltar"> {{estamos}} </div>
                        </div>

                        <div class="btn-group">
                            <button type="button" class="btn btn-outline-secondary btn-sm text-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="bi bi-person-circle me-2"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                                <li>
                                    <button class="dropdown-item INN-dropdown-item" type="button" (click)="logout()">
                                        Cerrar sesión
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</nav>